module.exports = __webpack_public_path__ + "img/default.582718c1.jpg";